import React, { useState } from 'react'
import NumberInput from 'components/NumberInput'

const Number = ({ onChange, className }) => {
  const [number, setNumber] = useState()
  const handleOnChange = (n) => {
    setNumber(n)
    const value = n.toString()
    onChange({
      params: { label: value, value },
      isTriggered: true,
      number: n
    })
  }

  return (
    <NumberInput
      className={`${className}-number`}
      labelText='Value'
      onChange={handleOnChange}
      value={number}
    />
  )
}

export default Number
